import { render } from "./TraitementConsultation.vue?vue&type=template&id=53155c69&scoped=true"
import script from "./TraitementConsultation.vue?vue&type=script&lang=js"
export * from "./TraitementConsultation.vue?vue&type=script&lang=js"

import "./TraitementConsultation.vue?vue&type=style&index=0&id=53155c69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53155c69"]])

export default __exports__